import HeroSection from './components/HeroSection';
import ContentSection from './components/ContentSection';
import React, { useEffect, useState } from "react"

import './App.css';

function App() {
  const [contentLoaded, setContentLoaded] = useState(false)
  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.classList.add('no-scroll');
  },[contentLoaded])
  return (
    <div className="App">
      <HeroSection loadContent={(isContentLoaded) => { setContentLoaded(isContentLoaded) }}/>
      <ContentSection contentLoaded={contentLoaded}  />
    </div>
  );
}

export default App;
